<div class="center-95" #arrayContainer>
  <div class="array-parameters-button">
    <ng-container *ngIf="filterFields != null && filterFields.length > 0">
      <div style="float : left; padding-left: 10px;">
        <mat-form-field style="width : calc(100% - 10px)">
          <input matInput (input)="filter($event, 'contains')" placeholder="recherche globale" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
    </ng-container>
    <ng-container *ngIf="allowArrayCustomisation ">
      <button mat-icon-button color="primary" [matMenuTriggerFor]="menuArraySetting100">
        <mat-icon>settings</mat-icon>
      </button>
    </ng-container>
  </div>
  <div style="height : 100%">
    <p-table #dt [value]="objectList" [columns]="columnsDefinition" [globalFilterFields]="filterFields"
      [reorderableColumns]="allowArrayCustomisation" [rows]="defaultRows" [showCurrentPageReport]="true"
      [autoLayout]="false" [loading]="loading" [paginator]="displayPaginator" [scrollable]="true" 
      [rowsPerPageOptions]="rowsPerPageOptions" [columnResizeMode]="columnResizeMode" [scrollHeight]="ScrollableHeight"
      [paginatorStyleClass]="styleClassPaginator" [resizableColumns]="allowArrayCustomisation" selectionMode="single"
      [currentPageReportTemplate]="currentPageReportTemplate" sortMode="multiple" dataKey="id"
      (onColReorder)="columnsReorder($event)" scrollHeight="flex" (onColResize)="columnsResized($event)"
      [styleClass]="styleClass">
      <!-- dataKey="id" adding this generate bug for multiple selection, version bug ? || todo  [resizableColumns]="allowArrayCustomisation" with scale 0.75-->
      <ng-template pTemplate="paginatorright">
        <div *ngIf="loading == false" [class.display-none]="!displayPaginator" class="paginator">
          <!-- [class.paginator-with-variable-height]="heightMode == 'variable'"> -->
          <span>
            <button mat-icon-button (click)="setPage(currentPage - 1)" [disabled]="currentPage <= 1">
              <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
          </span>
          <span style="line-height: 18px">Aller à
            <input type="text" [ngModel]="currentPage" (ngModelChange)="setPage($event)" class="page-number-input" />
            / {{ numbersPages }}
          </span>
          <span>
            <button mat-icon-button (click)="setPage(currentPage + 1)" *ngIf="table && objectList && table.rows"
              [disabled]="currentPage == objectList.length / table.rows">
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </span>
          <span class="paginator-counter" *ngIf="objectList?.length > 0 && table && table.first">
            {{ table.first + 1 }} à {{ lastItem }} sur {{ table.totalRecords }}
            <!-- Total : {{objectList.length}} Éléments -->
          </span>
          <span class="paginator-counter" *ngIf="objectList?.length == 0" style="color: white">
            0 éléments
            <!-- Total : {{objectList.length}} Éléments -->
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr [class.display-none]="!displayHeader">
          <ng-container *ngFor="let columnDefinition of columns">
            <ng-container [ngSwitch]="columnDefinition.type">
              <th *ngSwitchCase="'checkBox'" [ngStyle]="columnDefinition.ngStyle" pReorderableColumn pResizableColumn>
                {{columnDefinition.displayName}}
              </th>
              <th *ngSwitchCase="'icon'" [ngStyle]="columnDefinition.ngStyle" pReorderableColumn pResizableColumn>
              </th>
              <th *ngSwitchCase="'imgB64'" [ngStyle]="columnDefinition.ngStyle" pReorderableColumn pResizableColumn>
                <div class="form-filter-container inline-display">
                  <span class="sort-icon-span">
                    <p-sortIcon [field]="columnDefinition.name" [pSortableColumn]="columnDefinition.name"></p-sortIcon>
                  </span>
                  <span style="opacity: 0.7;">{{columnDefinition.displayName}}</span>
                </div>
              </th>
              <th *ngSwitchCase="'edit'" [ngStyle]="columnDefinition.ngStyle" pReorderableColumn pResizableColumn>
              </th>
              <th *ngSwitchDefault [ngStyle]="columnDefinition.ngStyle" pReorderableColumn pResizableColumn>
                <div class="form-filter-container inline-display">
                  <span class="sort-icon-span">
                    <p-sortIcon [field]="columnDefinition.name" [pSortableColumn]="columnDefinition.name"></p-sortIcon>
                  </span>
                  <!-- header name -->
                  <span class="form-filter-field">
                    <div class="inline-display">
                      <span *ngIf="columnDefinition.readOnly == true && columnDefinition.drop == null else notRO"
                        [class.form-filter-field]="(columnDefinition.localFilter && columnDefinition.drop != null) ||                      
                        (columnDefinition.localFilter != null && columnDefinition.help != null)"
                        class="inline-text-full-width" style="margin-left : 8px; color : grey">
                        {{columnDefinition.displayName}}
                      </span>
                      <ng-template #notRO>
                        <span [class.form-filter-field]="(columnDefinition.localFilter && columnDefinition.drop != null) || 
                        (columnDefinition.localFilter && columnDefinition.readOnly == true && columnDefinition.drop == null) ||
                        (columnDefinition.localFilter != null && columnDefinition.help != null)"
                          class="inline-text-full-width">
                          {{columnDefinition.displayName}}
                        </span>
                      </ng-template>
                      <span style="display : contents" style="opacity: 0.7;">
                        <ng-container *ngIf="columnDefinition.help != null">
                          <mat-icon [matTooltip]="columnDefinition.help" [matTooltipClass]="toolTipsClass"
                            matTooltipPosition="above" class="header-help-tooltip-icon">help
                          </mat-icon>
                        </ng-container>
                        <ng-container *ngIf="columnDefinition.drop != null && columnDefinition.readOnly == false">
                          <!-- &nbsp;(<mat-icon>splitscreen</mat-icon>) -->
                          <mat-icon
                            [matTooltip]="'Glisser/déposer depuis le vivier \'' + columnDefinition.drop.dropName+'\''"
                            [matTooltipClass]="toolTipsClass" matTooltipPosition="above"
                            class="header-help-tooltip-icon">help
                          </mat-icon>
                        </ng-container>
                      </span>
                    </div>
                  </span>
                  <!-- filter -->
                  <span *ngIf="columnDefinition.localFilter">
                    <span>
                      <button mat-icon-button [matMenuTriggerFor]="arrayFilter" class="small-mat-icon-button">
                        <mat-icon class="array-filter-icon"
                          [class.activate-filtre]="filterList[columnDefinition.name] != null"
                          (click)="focusFilterInput(inputFilter)">
                          filter_alt
                        </mat-icon>
                      </button>
                    </span>
                    <mat-menu #arrayFilter="matMenu" class="prime-ng-d4-filter-menu">
                      <div class="array-filter-container" (click)="$event.stopPropagation();">
                        <mat-form-field class="form-field-without-underline">
                          <input matInput type="text" (input)="filter($event, columnDefinition.name)"
                            placeholder="Rechercher" appendTo="body" #inputFilter />
                        </mat-form-field>
                      </div>
                    </mat-menu>
                    <!-- <mat-menu #menuArraySetting="matMenu" class="prime-ng-d4-parameter-wheel">
                      <div data-id="prime-ng-d4-filter">
                        <button mat-menu-item (click)="resetFilters()" [disabled]="ObjectKeys(filterList).length == 0">
                          <mat-icon>filter_alt_off</mat-icon>
                          <span>Supprimer les filtres</span>
                        </button>
                        <button mat-menu-item (click)="resetLocalConfiguration()">
                          <mat-icon>restart_alt</mat-icon>
                          <span>Réinitialiser les colonnes</span>
                        </button>
                      </div>
                    </mat-menu> -->
                  </span>
                </div>
              </th>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-object let-ri="rowIndex" let-rowIndex="rowIndex" let-columns="columns">
        <tr class="p-selectable-row p-fixed-height-table " pDraggable="items" [ngStyle]="trNgStyle" 
          (onDragStart)="dragStart($event,object)" (onDragEnd)="dragEnd($event)"> 
          <!-- [class.droppable-array-bg]="itemDragMvt" [class.drag-over]="itemDragMvt == true && dragRowOver == ri" -->
          <ng-container *ngFor="let columnDefinition of columnsDefinition">
            <ng-container [ngSwitch]="columnDefinition.type">
              <td *ngSwitchCase="'icon'" (click)="objectAction(object, columnDefinition.name )"
                [ngStyle]="columnDefinition.ngStyle">
                <mat-icon class="mat-icon-in-D4-row"
                  *ngIf="columnDefinition.help == null">{{columnDefinition.displayName}}</mat-icon>
                <mat-icon class="mat-icon-in-D4-row" *ngIf="columnDefinition.help != null"
                  [matTooltip]="columnDefinition.help" [matTooltipClass]="toolTipsClass" matTooltipPosition="below"
                  matTooltipShowDelay="350">
                  {{columnDefinition.displayName}}</mat-icon>
              </td>
              <td *ngSwitchCase="'edit'" [ngStyle]="columnDefinition.ngStyle">
                <mat-icon *ngIf="columnDefinition.help == null">edit</mat-icon>
                <mat-icon *ngIf="columnDefinition.help != null" [matTooltip]="columnDefinition.help"
                  [matTooltipClass]="toolTipsClass" matTooltipPosition="below" matTooltipShowDelay="350">
                  edit</mat-icon>
              </td>
              <td *ngSwitchCase="'imgB64'" [ngStyle]="columnDefinition.ngStyle">
                <img [src]="getImgB64(columnDefinition.name, object)">
              </td>
              <td *ngSwitchCase="'geolocalisation'" (click)="openLocation(object,columnDefinition.name ,$event) "
                [ngStyle]="columnDefinition.ngStyle">
                <ng-container
                  *ngIf="getObject(columnDefinition.name, object).longitude != undefined && getObject(columnDefinition.name, object).longitude != ''">
                  <mat-icon *ngIf="columnDefinition.help == null">place</mat-icon>
                  <mat-icon *ngIf="columnDefinition.help != null" [matTooltip]="columnDefinition.help"
                    [matTooltipClass]="toolTipsClass" matTooltipPosition="below" matTooltipShowDelay="350">
                  </mat-icon>
                </ng-container>
              </td>
              <td *ngSwitchCase="'summary'" (click)="openSummary(object) " [ngStyle]="columnDefinition.ngStyle">
                <mat-icon *ngIf="columnDefinition.help == null">summarize</mat-icon>
                <mat-icon *ngIf="columnDefinition.help != null" [matTooltip]="columnDefinition.help"
                  [matTooltipClass]="toolTipsClass" matTooltipPosition="below" matTooltipShowDelay="350">
                </mat-icon>
              </td>
              <!--
                ---------- read only row------------
                -->
              <td *ngSwitchCase="'checkBox'" [ngStyle]="columnDefinition.ngStyle" class="mat-checkbox-in-D4-row">
                <p-tableCheckbox [value]="object" [disabled]="true" style="display :contents"></p-tableCheckbox>
              </td>
              <td *ngSwitchCase="'booleanCheckBox'" [ngStyle]="columnDefinition.ngStyle">
                <mat-checkbox class="user-selection" [ngModel]="getObject(columnDefinition.name, object)"
                  [class.display-none]="getObject(columnDefinition.name, object) != true &&  getObject(columnDefinition.name, object) != false"
                  [disabled]="true"
                  [class.disabled-mat-checkbox-checked-bg-color-force]="getObject(columnDefinition.name, object) == true"></mat-checkbox>
              </td>
              <td *ngSwitchCase="'textArea'" class="cursor-default text-area-type" [ngStyle]="columnDefinition.ngStyle"
                [class.no-ellipsis]="columnDefinition.printLine != null">
                <span class="p-column-title" id="{{'colIndex'+arrayGuid + ri}}">{{columnDefinition.displayName}}</span>
                <!--standard value-->
                <ng-container *ngIf="(columnDefinition.helpValue == undefined || columnDefinition.helpValue == false ) && 
                                      (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false) ">
                  <span>
                    <button mat-icon-button class="small-mat-icon-button"
                      (click)="displayTextArea(columnDefinition.name, object, false)"><mat-icon>expand_content</mat-icon></button>
                  </span>
                  <span class="image-text cursor-default">
                    {{getObject(columnDefinition.name, object)}} </span>

                </ng-container>
                <!-- value with tooltip -->
                <ng-container *ngIf="(columnDefinition.helpValue != undefined && columnDefinition.helpValue == true ) && 
                                      (columnDefinition.copyBtn == undefined || columnDefinition?.copyBtn == false)">
                  <span class="image-text cursor-default" [matTooltip]="getObjectToolTip(columnDefinition.name, ri)"
                    [matTooltipClass]="toolTipsClass" matTooltipPosition="below" matTooltipShowDelay="500">
                    {{getObject(columnDefinition.name, object)}} </span>
                  <span>
                    <button mat-icon-button class="small-mat-icon-button"
                      (click)="displayTextArea(columnDefinition.name, object, false)"><mat-icon>expand_content</mat-icon></button>
                  </span>
                </ng-container>
              </td>
              <td *ngSwitchCase="'string'" class="cursor-default read-only-td" [ngStyle]="columnDefinition.ngStyle"
                [class.no-ellipsis]="columnDefinition.printLine != null">
                <span class="p-column-title" id="{{'colIndex'+arrayGuid + ri}}">{{columnDefinition.displayName}}</span>
                <!-- popup configuration button -->
                <div>
                  <span>
                    <ng-container *ngIf="columnDefinition.popUpComponent != null">
                      <div class="setting-btn-in-array">
                        <button mat-icon-button (click)="showPopUp(columnDefinition.popUpComponent, object, $event)"
                          class="small-mat-icon-button" [matTooltipClass]="toolTipsClass" matTooltipPosition="below"
                          matTooltipShowDelay="350" matTooltip="paramétrage">
                          <mat-icon>settings</mat-icon>
                        </button>
                      </div>
                    </ng-container>
                  </span>
                  <!--standard value-->
                  <span class="image-text cursor-default"
                    *ngIf="(columnDefinition.helpValue == undefined || columnDefinition.helpValue == false ) && 
                    (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false) && columnDefinition.printLine == null ">
                    {{getObject(columnDefinition.name, object)}} </span>
                  <!-- value with tooltip -->
                  <span class="image-text cursor-default"
                    *ngIf="(columnDefinition.helpValue != undefined && columnDefinition.helpValue == true ) && 
                              (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false) && columnDefinition.printLine == null"
                    [matTooltip]="getObjectToolTip(columnDefinition.name, ri)" [matTooltipClass]="toolTipsClass"
                    matTooltipPosition="below" matTooltipShowDelay="500">
                    {{getObject(columnDefinition.name, object)}} </span>
                  <!-- value generated with methode  -->
                  <ng-container *ngIf="columnDefinition.printLine != null">
                    <ng-container
                      *ngIf="callmethode(columnDefinition.printLine, object).bottomLine == '' ; else twoLinesRow">
                      <div style="display:contents" class="image-text cursor-default"
                        [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe:'html'">
                      </div>
                    </ng-container>
                    <ng-template #twoLinesRow>
                      <div style="display:inline-grid ; vertical-align: middle; margin-top : -10px">
                        <div class="image-text cursor-default"
                          [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe:'html'"></div>
                        <div class="image-text cursor-default" style="font-size : 0.8em"
                          [innerHTML]="callmethode(columnDefinition.printLine, object).bottomLine| safePipe:'html'">
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                  <!-- value with copie/past -->
                  <ng-container *ngIf="columnDefinition.copyBtn">
                    <span class="image-text cursor-default text-ro-with-copy-btn"> {{getObject(columnDefinition.name,
                      object)}} </span>
                    <div class="copy-btn-in-array">
                      <button mat-icon-button ngxClipboard [cbContent]="getObject(columnDefinition.name,object)"
                        (click)="clipBoardContentInfo()" class="small-mat-icon-button">
                        <mat-icon matTooltip="copier le contenu" matTooltipClass="tool-tip-size-0-7-em"
                          matTooltipPosition="below" matTooltipShowDelay="400">
                          content_copy</mat-icon>
                      </button>
                    </div>
                  </ng-container>
                </div>
              </td>
              <td *ngSwitchCase="'link'" class="cursor-default" [ngStyle]="columnDefinition.ngStyle"
                [class.no-ellipsis]="columnDefinition.printLine != null"
                (click)="downloadLink(object, columnDefinition.name,  $event)">
                <span class="p-column-title" id="{{'colIndex'+arrayGuid + ri}}">{{columnDefinition.displayName}}</span>
                <!-- popup configuration button -->

                <!-- display help over -->
                <span class="image-text cursor-default string-as-link-ro"
                  *ngIf="(columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false) && columnDefinition.printLine == null ">
                  {{getObject(columnDefinition.name, object)}} </span>

                <!-- specific print line -->
                <ng-container *ngIf="columnDefinition.printLine != null">
                  <ng-container
                    *ngIf="callmethode(columnDefinition.printLine, object).bottomLine == '' ; else twoLinesRow">
                    <div style="display:contents" class="image-text cursor-default"
                      [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe:'html'">
                    </div>
                  </ng-container>
                  <ng-template #twoLinesRow>
                    <span style="display:inline-grid ; vertical-align: middle; ; margin-top : -10px">
                      <div class="image-text cursor-default"
                        [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe:'html'"></div>
                      <div class="image-text cursor-default" style="font-size : 0.8em"
                        [innerHTML]="callmethode(columnDefinition.printLine, object).bottomLine| safePipe:'html'">
                      </div>
                    </span>
                  </ng-template>
                </ng-container>
                <!-- copy btn -->
                <ng-container *ngIf="columnDefinition.copyBtn">
                  <span class="image-text cursor-default text-ro-with-copy-btn string-as-link-ro">
                    {{getObject(columnDefinition.name,
                    object)}} </span>
                  <div class="copy-btn-in-array">
                    <button mat-icon-button ngxClipboard [cbContent]="getObject(columnDefinition.name,object)"
                      (click)="clipBoardContentInfo()" class="small-mat-icon-button">
                      <mat-icon matTooltip="copier le contenu" matTooltipClass="tool-tip-size-0-7-em"
                        matTooltipPosition="below" matTooltipShowDelay="400">
                        content_copy</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </td>
              <td *ngSwitchCase="'number'" class="cursor-default" [ngStyle]="columnDefinition.ngStyle">
                <span class="p-column-title" id="{{'colIndex'+arrayGuid + ri}}">{{columnDefinition.displayName}}</span>
                <!--standard value-->
                <span class="image-text cursor-default" *ngIf="(columnDefinition.helpValue == undefined || columnDefinition.helpValue == false ) && 
                    (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false) ">
                  {{getObject(columnDefinition.name, object) | number}} </span>
                <!-- value with tooltip -->
                <span class="image-text cursor-default" *ngIf="(columnDefinition.helpValue != undefined && columnDefinition.helpValue == true ) && 
                              (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false)"
                  [matTooltip]="getObjectToolTip(columnDefinition.name, ri)" [matTooltipClass]="toolTipsClass"
                  matTooltipPosition="below" matTooltipShowDelay="500">
                  {{getObject(columnDefinition.name, object) | number}} </span>
                <!-- value with copie/past -->
                <ng-container *ngIf="columnDefinition.copyBtn">
                  <span class="image-text cursor-default text-ro-with-copy-btn"> {{getObject(columnDefinition.name,
                    object) | number}} </span>
                  <div class="copy-btn-in-array">
                    <button mat-icon-button ngxClipboard
                      [cbContent]="(getObject(columnDefinition.name,object) | number) || undefined"
                      (click)="clipBoardContentInfo()" class="small-mat-icon-button">
                      <mat-icon matTooltip="copier le contenu" matTooltipClass="tool-tip-size-0-7-em"
                        matTooltipPosition="below" matTooltipShowDelay="400">
                        content_copy</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </td>
              <td *ngSwitchCase="'decimal'" class="cursor-default" [ngStyle]="columnDefinition.ngStyle">
                <!--standard value-->
                <span class="image-text cursor-default" *ngIf="(columnDefinition.helpValue == undefined || columnDefinition.helpValue == false ) && 
                    (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false) ">
                  {{getObject(columnDefinition.name, object) | number : '1.2-2'}} </span>
                <!-- value with tooltip -->
                <span class="image-text cursor-default" *ngIf="(columnDefinition.helpValue != undefined && columnDefinition.helpValue == true ) && 
                              (columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false)"
                  [matTooltip]="getObjectToolTip(columnDefinition.name, ri)" [matTooltipClass]="toolTipsClass"
                  matTooltipPosition="below" matTooltipShowDelay="500">
                  {{getObject(columnDefinition.name, object) | number : '1.2-2'}} </span>
                <!-- value with copie/past -->
                <ng-container *ngIf="columnDefinition.copyBtn">
                  <span class="image-text cursor-default text-ro-with-copy-btn"> {{getObject(columnDefinition.name,
                    object) | number : '1.2-2'}} </span>
                  <div class="copy-btn-in-array">
                    <button mat-icon-button ngxClipboard class="small-mat-icon-button"
                      [cbContent]="(getObject(columnDefinition.name,object) | number : '1.2-2') || undefined"
                      (click)="clipBoardContentInfo()">
                      <mat-icon matTooltip="copier le contenu" matTooltipClass="tool-tip-size-0-7-em"
                        matTooltipPosition="below" matTooltipShowDelay="400">
                        content_copy</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </td>
              <td *ngSwitchCase="'currency'" class="cursor-default" [ngStyle]="columnDefinition.ngStyle">
                <span class="p-column-title" id="{{'colIndex'+arrayGuid + ri}}">{{columnDefinition.displayName}}</span>
                <span class="image-text cursor-default"
                  *ngIf="columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false">
                  {{getObject(columnDefinition.name, object) | currency:'EUR'}} </span>
                <ng-container *ngIf="columnDefinition.copyBtn">
                  <span class="image-text cursor-default text-ro-with-copy-btn"> {{getObject(columnDefinition.name,
                    object)| currency:'EUR'}} </span>
                  <div class="copy-btn-in-array">
                    <button mat-icon-button ngxClipboard class="small-mat-icon-button"
                      [cbContent]="(getObject(columnDefinition.name,object) | currency:'EUR') || undefined"
                      (click)="clipBoardContentInfo()">
                      <mat-icon matTooltip="copier le contenu" matTooltipClass="tool-tip-size-0-7-em"
                        matTooltipPosition="below" matTooltipShowDelay="400">
                        content_copy</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </td>
              <td *ngSwitchCase="'phone'" class="cursor-default" [ngStyle]="columnDefinition.ngStyle"
                (click)="phoneLink(object, columnDefinition.name,  $event)">
                <span class="p-column-title" id="{{'colIndex'+arrayGuid + ri}}">{{columnDefinition.displayName}}</span>
                <span class="image-text cursor-default text-ro-with-copy-btn string-as-link-ro"
                  *ngIf="columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false">
                  {{getObject(columnDefinition.name, object)}}
                  <!-- <div class="copy-btn-in-array">
                      <a mat-icon-button *ngIf="getObject(columnDefinition.name, object).length > 8"
                        matTooltip="Contacter" class="small-mat-icon-button"
                        [href]="'tel:'+getObject(columnDefinition.name, object)">
                        <mat-icon>phone</mat-icon></a>
                    </div> -->
                </span>
                <ng-container *ngIf="columnDefinition.copyBtn">
                  <span class="image-text cursor-default text-ro-with-copy-btn string-as-link-ro">
                    {{getObject(columnDefinition.name,
                    object)}} </span>
                  <div class="copy-btn-in-array">
                    <button mat-icon-button ngxClipboard [cbContent]="getObject(columnDefinition.name,object) "
                      (click)="clipBoardContentInfo()" class="small-mat-icon-button">
                      <mat-icon matTooltip="copier le contenu" matTooltipClass="tool-tip-size-0-7-em"
                        matTooltipPosition="below" matTooltipShowDelay="400">
                        content_copy</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </td>
              <td *ngSwitchCase="'mail'" (click)="mailLink(object, columnDefinition.name,  $event)"
                class="cursor-default" [ngStyle]="columnDefinition.ngStyle">
                <span class="p-column-title" id="{{'colIndex'+arrayGuid + ri}}">{{columnDefinition.displayName}}</span>
                <span class="image-text cursor-default text-ro-with-copy-btn string-as-link-ro"
                  *ngIf="columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false">
                  {{getObject(columnDefinition.name, object)}}
                </span>
                <ng-container *ngIf="columnDefinition.copyBtn">
                  <span class="image-text cursor-default text-ro-with-copy-btn string-as-link-ro">
                    {{getObject(columnDefinition.name,
                    object)}} </span>
                  <div class="copy-btn-in-array">
                    <button mat-icon-button ngxClipboard [cbContent]="getObject(columnDefinition.name,object) "
                      (click)="clipBoardContentInfo()" class="small-mat-icon-button">
                      <mat-icon matTooltip="copier le contenu" matTooltipClass="tool-tip-size-0-7-em"
                        matTooltipPosition="below" matTooltipShowDelay="400">
                        content_copy</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </td>
              <td *ngSwitchCase="'date'" class="cursor-default" [ngStyle]="columnDefinition.ngStyle">
                <span class="p-column-title" id="{{'colIndex'+ arrayGuid + ri}}">{{columnDefinition.displayName}}</span>
                <span class="image-text cursor-default"
                  *ngIf="columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false">
                  {{getObject(columnDefinition.name, object) | date:'shortDate'}} </span>
                <ng-container *ngIf="columnDefinition.copyBtn">
                  <span class="image-text cursor-default text-ro-with-copy-btn"> {{getObject(columnDefinition.name,
                    object)|date}} </span>
                  <div class="copy-btn-in-array">
                    <button mat-icon-button ngxClipboard
                      [cbContent]="(getObject(columnDefinition.name,object) | date:'shortDate') || undefined"
                      (click)="clipBoardContentInfo()" class="small-mat-icon-button">
                      <mat-icon matTooltip="copier le contenu" matTooltipClass="tool-tip-size-0-7-em"
                        matTooltipPosition="below" matTooltipShowDelay="400">
                        content_copy</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </td>
              <td *ngSwitchCase="'dateTime'" class="cursor-default" [ngStyle]="columnDefinition.ngStyle">
                <span class="p-column-title" id="{{'colIndex'+arrayGuid + ri}}">{{columnDefinition.displayName}}</span>
                <span class="image-text cursor-default"
                  *ngIf="columnDefinition.copyBtn == undefined || columnDefinition.copyBtn == false">
                  {{getObject(columnDefinition.name, object)| date:'dd LLL yyyy à HH:mm'}} </span>
                <ng-container *ngIf="columnDefinition.copyBtn">
                  <span class="image-text cursor-default text-ro-with-copy-btn"> {{getObject(columnDefinition.name,
                    object)| date:'dd LLL yyyy à HH:mm'}} </span>
                  <div class="copy-btn-in-array">
                    <button mat-icon-button ngxClipboard
                      [cbContent]="(getObject(columnDefinition.name,object) | date:'dd LLL yyyy à HH:mm') || undefined"
                      (click)="clipBoardContentInfo()" class="small-mat-icon-button">
                      <mat-icon matTooltip="copier le contenu" matTooltipClass="tool-tip-size-0-7-em"
                        matTooltipPosition="below" matTooltipShowDelay="400">
                        content_copy</mat-icon>
                    </button>
                  </div>
                </ng-container>
              </td>
              <td *ngSwitchCase="'enum'" class="cursor-default" [ngStyle]="columnDefinition.ngStyle">
                <span class="p-column-title" id="{{'colIndex'+arrayGuid + ri}}">{{columnDefinition.displayName}}</span>
                <mat-form-field style="top: 9px; width : 90%" class="cursor-default"
                  class="mat-mdc-text-field-wrapper-small">
                  <mat-select [value]="getObject(columnDefinition.name, object)" data-id="prime-ng-d4-enum"
                    class="mat-mdc-text-field-wrapper-small" (selectionChange)="editCellInit(object, $event)"
                    [disabled]="true">
                    <mat-option *ngFor="let enum of columnDefinition.enum" [value]="enum.value">
                      {{enum.displayValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td *ngSwitchCase="'booleanDropDown'" class="cursor-default" [ngStyle]="columnDefinition.ngStyle">
                <span class="p-column-title" id="{{'colIndex'+arrayGuid + ri}}">{{columnDefinition.displayName}}</span>
                <mat-form-field style="top: 9px; width : 90%" class="cursor-default"
                  class="mat-mdc-text-field-wrapper-small">
                  <mat-select [value]="getObject(columnDefinition.name, object)"
                    class="mat-mdc-text-field-wrapper-small" (selectionChange)="editCellInit(object,$event)"
                    [disabled]="true">
                    <mat-option [value]="true">Oui</mat-option>
                    <mat-option [value]="false">Non</mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td *ngSwitchCase="'duration'" [pEditableColumn]="object" [pEditableColumnField]="columnDefinition.name"
                [ngStyle]="columnDefinition.ngStyle">
                <span class="p-column-title" id="{{'colIndex'+arrayGuid + ri}}">duration-mat-form</span>
                <ng-container *ngIf="columnDefinition.printLine != null">
                  <ng-container
                    *ngIf="callmethode(columnDefinition.printLine, object).bottomLine == '' ; else twoLinesRow">
                    <div style="display:contents" class="image-text cursor-default"
                      [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe:'html'">
                    </div>
                  </ng-container>
                  <ng-template #twoLinesRow>
                    <div style="display:inline-grid ; vertical-align: middle; margin-top : -10px">
                      <span class="image-text cursor-default"
                        [innerHTML]="callmethode(columnDefinition.printLine, object).topLine | safePipe:'html'"></span>
                      <span class="image-text cursor-default"
                        [innerHTML]="callmethode(columnDefinition.printLine, object).bottomLine | safePipe:'html'"
                        style="font-size : 0.8em"></span>
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container *ngIf="columnDefinition.printLine == null">
                  {{getObject(columnDefinition.name, object)}}
                </ng-container>
              </td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" style="vertical-align: middle; margin : auto">{{nullArrayDisplayText}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>


<mat-menu #menuArraySetting100="matMenu">
  <div>
    <button mat-menu-item (click)="resetFilters()" [disabled]="ObjectKeys(filterList).length == 0">
      <mat-icon>filter_alt_off</mat-icon>
      <span>Supprimer les filtres</span>
    </button>
    <button mat-menu-item (click)="resetLocalConfiguration()">
      <mat-icon>restart_alt</mat-icon>
      <span>Réinitialiser les colonnes</span>
    </button>
  </div>
</mat-menu>